/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 */

import * as Optimizely from '@zcode/nr/es/shared/packages/optimizely-middleware'
import { FILTERS_SET } from '@zcode/nr/es/shared/thirdParty/optimizely/constants'
import type { Filters, GetState } from '@zcode/state-type'
import deepequal from 'fast-deep-equal'
import { updateUrlFromLocationFilter } from '../../router/thunks/updateUrlFromLocationFilter'
import { trackFilterChangeEvent } from '../../traktor/thunks/trackFilterChangeEvent'
import type { Dispatch } from '../../types'
import { setFiltersChanged, setIsZoeSearch, updateFilters } from '../actions'
import { selectFilters } from '../selectors'

export const handleFilterChange =
  (newFilters: Filters, updateUrl = true, isZoeSearch = false) =>
  (dispatch: Dispatch, getState: GetState) => {
    const currentFilters = selectFilters(getState())

    if (!deepequal(currentFilters, newFilters)) {
      dispatch(setFiltersChanged(true))
      dispatch(setIsZoeSearch(isZoeSearch))
      dispatch(updateFilters({ filters: newFilters, replace: true }))
      updateUrl &&
        dispatch(
          updateUrlFromLocationFilter({
            omitBox: false,
            keepSameBox: true,
          })
        )
      dispatch(trackFilterChangeEvent())
      dispatch(Optimizely.track({ eventKey: FILTERS_SET }))
    }
  }
